'use client'
import React, { useEffect, useState } from 'react'
import cls from 'classnames'
import styles from './index.module.scss'
import { Flex, Popover } from 'antd'
import { useLocale } from '@/components/withPageLocaleProvider'
import { useParams } from 'next/navigation'
import Image from 'next/image'
import link from '@/utils/link'
import { HCNextLink, useHCRouter } from '../HCNextLink'
import { useAuthenticate } from 'core/components/Authenticate'
import arrowDownIcon from './img/arrow-downIcon.svg'

export default function Footer() {
  const t = useLocale()
  const { lang } = useParams()
  const router = useHCRouter()
  const { loginData } = useAuthenticate()

  const [hostname, setHostname] = useState('')
  useEffect(() => {
    setHostname(window.location.hostname)
  }, [])

  const [activeIndex, setActiveIndex] = useState<number | null>(null) // 用于控制展开的索引

  const aboutUsList = [
    { label: t('footer_002'), href: link.footer_001, target: '_blank' },
    { label: t('support_011'), href: link.footer_003, target: '_blank' },
    { label: t('job_001'), href: '/position', target: '' },
    { label: t('footer_029'), href: '/status', target: '' },
    { label: t('footer_012'), href: link.footer_005, target: '_blank' },
    { label: t('footer_013'), href: link.footer_006, target: '_blank' },
    { label: t('footer_014'), href: link.footer_007, target: '_blank' },
  ]
  const productList = [
    { label: 'NFT', href: '/nft/home', target: '' },
    { label: 'Startup', href: '/ieo', target: '' },
    { label: t('financial_004'), href: '/wealthManagement', target: '' },
    { label: t('pledg_001'), href: '/pledgeBorrowMoney', target: '' },
    { label: t('header_007'), href: '/trade/exchange/?tradeCode=btc_usdt', target: '' },
    { label: t('header_007_1'), href: '/contract/exchange/trade?tradeName=btcusdt', target: '' },
    { label: t('marginAccount_001'), href: '/margin/trade', target: '' },
  ]
  const serviceList = [
    { label: t('index_047'), href: '/c2c/trade', target: '' },
    { label: t('creditCard_002'), href: '/c2c/trade/creditCardIndex', target: '' },
    { label: t('footer_056'), href: '/c2c/business', target: '' },
    { label: t('header_050'), href: '/user/ic', target: '' },
    { label: t('hotcoinWeb_v1_22_56_LiveStreaming'), href: '/live', target: '' },
    { label: t('vip_004'), href: '/vip', target: '' },
    { label: t('download_page_14'), href: '/app/downLoad', target: '' },
    { label: t('footer_057'), href: '/desktop', target: '' },
  ]
  const supportList = [
    { label: t('learn_016'), href: '/learn/index', target: '' },
    { label: t('footer_010'), href: '/support/index', target: '' },
    /* {
      label: t('footer_055'),
      href: '',
      target: '',
      onClick: () => {
        // 拉起客服
      },
    }, */
    {
      label: t('userfeedback_001'),
      href: '',
      target: '',
      onClick: () => {
        if (!loginData) {
          router.push('/login')
        } else {
          router.push('/userfeedback')
        }
      },
    },
    {
      label: t('footer_008'),
      href: '',
      target: '',
      onClick: () => {
        window.open(lang == 'zh_CN' ? link.currency_application : link.currency_application_en, '_blank')
      },
    },
    {
      label: t('footer_005'),
      href: '/apiDocument',
      target: '',
    },
    { label: t('footer_015'), href: '/rateStandard', target: '' },
    { label: t('footer_051'), href: '/coinInfo', target: '' },
    {
      label: t('footer_058'),
      href: '',
      target: '',
      onClick: () => {
        window.open(lang == 'zh_CN' ? link.nft_project_application_zh : link.nft_project_application_en, '_blank')
      },
    },
    { label: t('support_032'), href: '/support/official-channel', target: '' },
  ]
  const contactUsList = [
    { label: t('footer_017'), value: 'Service@hotcoin.com' },
    { label: t('footer_049'), value: 'Product@hotcoin.com' },
    { label: t('footer_018'), value: 'Business@hotcoin.com' },
    { label: t('footer_050'), value: 'Casecn@hotcoin.com' },
  ]
  const toggleSection = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index) // 切换展开或折叠
  }

  return (
    <div className={cls([styles['footer-wrap'], 'footer'])}>
      <div className={styles.footerContent}>
        <div className={cls(styles['app-logo'], 'hide-pc')}>
          {/* 手机显示 */}
          <Image src="/images/footer/logo.svg" width={120} height={26} alt="" unoptimized />
          <div style={{ color: '#758394' }}>&copy;2017-2025 {hostname}</div>
        </div>

        <div className={cls(styles['common-list-wrap'], 'flex justify-between')}>
          <div className={styles['common-list']}>
            <div
              className={styles['common-title']}
              onClick={() => toggleSection(1)} // 点击切换展开状态
            >
              {t('footer_001')}
              <Image
                src={arrowDownIcon}
                alt=""
                className={cls(styles.downOutlined, 'f12 hide-pc')}
                style={{ transform: activeIndex === 1 ? 'rotate(180deg)' : 'rotate(0deg)' }}
              />
            </div>
            <div
              className={cls(styles['common-items'], {
                [styles.active]: activeIndex === 1,
              })}
            >
              <div className={styles['common-items-inner']}>
                {aboutUsList.map((item, i) => (
                  <div key={`aboutUs${i}`}>
                    <HCNextLink href={item.href} target={item.target} className={styles['common-item']}>
                      {item.label}
                    </HCNextLink>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className={styles['common-list']}>
            <div className={styles['common-title']} onClick={() => toggleSection(2)}>
              {t('footer_052')}
              <Image
                src={arrowDownIcon}
                alt=""
                className={cls(styles.downOutlined, 'f12 hide-pc')}
                style={{ transform: activeIndex === 2 ? 'rotate(180deg)' : 'rotate(0deg)' }}
              />
            </div>
            <div
              className={cls(styles['common-items'], {
                [styles.active]: activeIndex === 2,
              })}
            >
              <div className={styles['common-items-inner']}>
                {productList.map((item, i) => (
                  <div key={`product${i}`}>
                    <HCNextLink href={item.href} target={item.target} className={styles['common-item']}>
                      {item.label}
                    </HCNextLink>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className={styles['common-list']}>
            <div className={styles['common-title']} onClick={() => toggleSection(3)}>
              {t('footer_053')}
              <Image
                src={arrowDownIcon}
                alt=""
                className={cls(styles.downOutlined, 'f12 hide-pc')}
                style={{ transform: activeIndex === 3 ? 'rotate(180deg)' : 'rotate(0deg)' }}
              />
            </div>
            <div
              className={cls(styles['common-items'], {
                [styles.active]: activeIndex === 3,
              })}
            >
              <div className={styles['common-items-inner']}>
                {serviceList.map((item, i) => (
                  <div key={`service${i}`}>
                    <HCNextLink href={item.href} target={item.target} className={styles['common-item']}>
                      {item.label}
                    </HCNextLink>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className={styles['common-list']}>
            <div className={styles['common-title']} onClick={() => toggleSection(4)}>
              {t('footer_054')}
              <Image
                src={arrowDownIcon}
                alt=""
                className={cls(styles.downOutlined, 'f12 hide-pc')}
                style={{ transform: activeIndex === 4 ? 'rotate(180deg)' : 'rotate(0deg)' }}
              />
            </div>
            <div
              className={cls(styles['common-items'], {
                [styles.active]: activeIndex === 4,
              })}
            >
              <div className={styles['common-items-inner']}>
                {supportList.map((item, i) => (
                  <div key={`support${i}`}>
                    <HCNextLink
                      href={item.href}
                      target={item.target}
                      className={styles['common-item']}
                      onClick={(e) => {
                        if (item?.onClick) {
                          e.preventDefault()
                          item?.onClick?.()
                        }
                      }}
                    >
                      {item.label}
                    </HCNextLink>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className={styles['common-list']}>
            <div className={styles['common-title']} onClick={() => toggleSection(5)}>
              {t('footer_016')}
              <Image
                src={arrowDownIcon}
                alt=""
                className={cls(styles.downOutlined, 'f12 hide-pc')}
                style={{ transform: activeIndex === 5 ? 'rotate(180deg)' : 'rotate(0deg)' }}
              />
            </div>
            <div
              className={cls(styles['common-items'], {
                [styles.active]: activeIndex === 5,
              })}
            >
              <div className={styles['common-items-inner']}>
                {contactUsList.map((item, i) => (
                  <React.Fragment key={`contactUs${i}`}>
                    <div className={cls(styles['common-item'])} style={{ cursor: 'unset' }} key={`contactUs${i}`}>
                      <div className={cls(styles['common-label'])}>{item.label}</div>
                      <p>{item.value}</p>
                    </div>
                  </React.Fragment>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className={cls(styles['logoList'])}>
          <div className={cls(styles['app-logo'], 'show-pc')}>
            <Image src="/images/footer/logo.svg" width={140} height={48} alt="" unoptimized />
            <div>&copy;2017-2025 {hostname}</div>
          </div>

          <Flex className={cls(styles['logoListInner'])} align="center" gap={12}>
            <a className={styles['logo-list-item']} href="https://www.facebook.com/HotcoinExchange" target="_blank">
              <i className={cls('iconfont iconbianzu58', styles['logo-list-item-icon'])}></i>
            </a>
            <a className={styles['logo-list-item']} href="https://twitter.com/HotcoinGlobal" target="_blank">
              <i className={cls('iconfont icontuite', styles['logo-list-item-icon'])}></i>
            </a>

            <Popover
              content={
                <div style={{ width: '160px' }}>
                  <Image src="/images/footer/QR.png" width={160} height={160} alt="" unoptimized />
                  <div className="c7" style={{ textAlign: 'center', marginTop: '4px' }}>
                    {t('footer_024')}
                  </div>
                </div>
              }
            >
              <div className={styles['logo-list-item']}>
                <i className={cls('iconfont iconbianzu1', styles['logo-list-item-icon'])}></i>
              </div>
            </Popover>

            <Popover
              content={
                lang === 'zh_CN' ? (
                  <div style={{ width: '150px' }}>
                    <Image src="/images/footer/Telegram-cn.png" width={150} height={150} alt="" unoptimized />
                    <div style={{ textAlign: 'center' }}>
                      <a href="https://t.me/hotcoinglobalcn" target="_blank">
                        {t('footer_027')}
                      </a>
                    </div>
                  </div>
                ) : (
                  <div style={{ width: '150px' }}>
                    <Image src="/images/footer/Telegram-en.png" width={150} height={150} alt="" unoptimized />
                    <div style={{ textAlign: 'center' }}>
                      <a href="https://t.me/HotcoinEX" target="_blank">
                        {t('footer_028')}
                      </a>
                    </div>
                  </div>
                )
              }
            >
              <div className={styles['logo-list-item']}>
                <i className={cls('iconfont iconbianzu581', styles['logo-list-item-icon'])}></i>
              </div>
            </Popover>

            <a
              className={styles['logo-list-item']}
              href="https://coinmarketcap.com/exchanges/hotcoin-global/"
              target="_blank"
            >
              <div className={styles['logo-list-item-img1']}></div>
            </a>
          </Flex>
        </div>
      </div>
    </div>
  )
}
